import React from 'react';
import IconBase, { IconColor, IconSize } from './IconBase';

export type IconUsersProps = {
    color?: IconColor;
    size?: IconSize;
    className?: string;
    title?: string;
};

const IconUsers: React.FC<IconUsersProps> = ({
    color = 'primary',
    size = 'md',
    className = '',
    title = 'Users',
}) => (
    <IconBase color={color} size={size} className={className} title={title}>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16 3.128a4 4 0 0 1 0 7.744" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M22 21v-2a4 4 0 0 0-3-3.87" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="9" cy="7" r="4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    </IconBase>
);

export default IconUsers;
